import type { RouterActionsType } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { fg } from '@atlassian/jira-feature-gating';
import type { State } from '../../types.tsx';
import { getDraftEditUrl, getJcsDraftEditUrl } from '../../utils.tsx';

export const navigateCreateDraftRoute =
	({
		routerActions,
		projectKey,
		selectedSpaceKey,
		topicId,
		isJcs,
		helpCenterId,
		shouldOpenInNewTab,
	}: {
		routerActions: RouterActionsType;
		projectKey: string;
		selectedSpaceKey: string;
		topicId?: string;
		isJcs?: boolean;
		helpCenterId?: string;
		shouldOpenInNewTab?: boolean;
	}) =>
	async ({ getState }: StoreActionApi<State>) => {
		const { articleId, draftShareId } = { ...getState() };
		const EDIT_DRAFT_ROUTE =
			isJcs && fg('enable_articles_page_csm')
				? getJcsDraftEditUrl(
						projectKey,
						selectedSpaceKey,
						articleId,
						draftShareId,
						topicId,
						helpCenterId,
						shouldOpenInNewTab,
					)
				: getDraftEditUrl(projectKey, selectedSpaceKey, articleId, draftShareId, topicId);

		if (isJcs && shouldOpenInNewTab && fg('jcs_enhanced_article_view')) {
			if (typeof window !== 'undefined') {
				window.open(EDIT_DRAFT_ROUTE, '_blank', 'noopener,noreferrer');
			}
		} else {
			routerActions.push(EDIT_DRAFT_ROUTE);
		}
	};
